import { render, staticRenderFns } from "./_PlayerMonitorForm.vue?vue&type=template&id=3b5f51e5&"
import script from "./_PlayerMonitorForm.vue?vue&type=script&lang=ts&"
export * from "./_PlayerMonitorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports